import { apiRequest } from './client';

export const register = (payload) => apiRequest('/auth/register', { method: 'POST', body: payload });
export const login = (payload) => apiRequest('/auth/login', { method: 'POST', body: payload });
export const currentUser = (token) => apiRequest('/auth/me', { token });
